import { ReactNode } from "react";
import CloseBtn from "../ui/CloseBtn";
import PrimaryAnimatedBtn from "../ui/PrimaryAnimatedBtn";
import styles from "./modal.module.scss";

type Props = {
  onClickBtn: () => void;
  closeModal: () => void;
  title: string;
  children?: ReactNode;
  btnText?: string;
};

const Modal = ({
  onClickBtn,
  closeModal,
  title,
  children,
  btnText = "OK",
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className="mb-[24px] flex justify-between items-center">
          <div className="text-[24px] heading-[24px] font-bold">{title}</div>
          <CloseBtn onClick={closeModal} />
        </div>
        {children && <p className={styles.children}>{children}</p>}
        <PrimaryAnimatedBtn onClick={onClickBtn} extraClass="w-full">
          {btnText}
        </PrimaryAnimatedBtn>
      </div>
    </div>
  );
};

export default Modal;
